export class JobTranslationModel {
    constructor(data = {}) {
        this.id = data.id;
        this.external_translation = data.external_translation;
        this.internal_translation = data.internal_translation;
        this.job_id = data.job_id;
        this.language_id = data.language_id;
    }
}
